import React from 'react';
import { cn } from '../../utils/cn';

const StandardInput = ({ 
  label,
  error,
  helperText,
  type = 'text',
  className,
  ...props 
}) => {
  const baseStyles = 'w-full px-4 py-3 min-h-[48px] border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-100 disabled:cursor-not-allowed';
  
  const stateStyles = error 
    ? 'border-red-500 focus:border-red-500' :'border-gray-300 focus:border-teal-500';
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <input
        type={type}
        className={cn(
          baseStyles,
          stateStyles,
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-2 text-sm text-red-600">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-2 text-sm text-gray-500">{helperText}</p>
      )}
    </div>
  );
};

export default StandardInput;